import { meta } from "../src/landingPage/datasets/meta";
import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { LegalTemplate } from "../src/landingPage/views/LegalPages/template/LegalTemplate";

const SubprocessorPage = () => {
  const content = `
    <h1>Sub-processor Policy</h1>
    <p>Effective Date: June 15, 2022</p>
    <h2>Demyst as a Sub-processor</h2>
    <p>Demyst believes that external data is the next frontier of impact. We believe that the solutions to some of our biggest problems are "stuck in the lab" due to friction in data discovery, security, deployment, and scaling.  We believe that building the muscle to operationalize data is not a one time internal project, but a core need that creates a competitive advantage and outsized benefits to customers, enterprises, and society.</p>
    <p>Demyst acknowledges it has obligations to protect personal data under data privacy laws such as the European Union’s General Data Protection Regulation (GDPR), California’s Consumer Privacy Act (CCPA) and other applicable data privacy laws in our regions of operations.   We are committed to providing best in class data platform and data API services in compliance with all applicable laws and regulations.</p>
    <p>Data protection and security are, and always will be a top priority at Demyst. In addition to its proprietary security technologies, Demyst undergoes regular external assessments, including a SOC 2, Type 2 audit, every year to ensure Demyst’s technologies and processes are safe and secure.</p>
    <p>Demyst uses certain Sub-contractors (Processors where we act in a “Data Controller” capacity or Sub-processors where we act in a “Data Processor” capacity) to assist it in providing Demyst’s services, including the processing of personal data. Demyst is committed to partnering with both our processors and sub-processors that meet or exceed the privacy and security obligations Demyst is committed to providing to its clients. The following is an up-to-date list (as of the date of this policy) of the names and locations of Demyst’s subcontractors:</p>
    <table>
      <tbody>
        <tr class="odd">
          <td>
            <strong>Entity Name</strong>
          </td>
          <td>
            <strong>Subprocessing Activities</strong>
          </td>
          <td>
            <strong>Entity Country</strong>
          </td>
        </tr>
        <tr class="even">
          <td>Amazon Web Services Inc.</td>
          <td>Cloud Service Provider</td>
          <td>United States</td>
        </tr>
        <tr class="odd">
          <td>Google, LLC</td>
          <td>Cloud Service Provider</td>
          <td>United States</td>
        </tr>
        <tr class="even">
          <td>ZoomInfo, Inc.</td>
          <td>Marketing Analytics</td>
          <td>United States</td>
        </tr>
      </tbody>
    </table>
    <p>Demyst owns or controls access to the information systems infrastructure that Demyst uses to provide Demyst’s Services, other than as set forth herein. Currently, Demyst’s data platform systems used for hosting the Services are located in co-location facilities in the infrastructure sub-processors listed below:</p>
    <table>
      <tbody>
        <tr class="odd">
          <td>
            <strong>Entity Name</strong>
          </td>
          <td>
            <strong>Subprocessing Activities</strong>
          </td>
          <td>
            <strong>Entity Country</strong>
          </td>
        </tr>
        <tr class="even">
          <td>Amazon Web Services Inc.</td>
          <td>Cloud Service Provider</td>
          <td>United States</td>
        </tr>
        <tr class="odd">
          <td>Google, LLC</td>
          <td>Cloud Service Provider</td>
          <td>United States</td>
        </tr>
        <tr class="even">
          <td>Snowflake Inc.</td>
          <td>Cloud Service Provider</td>
          <td>United States</td>
        </tr>
      </tbody>
    </table>
  `;

  return (
    <>
      <NextHead
        currentPath="/subprocessor-policy"
        title={meta.subprocessor.title}
        description={meta.subprocessor.description}
      />
      <LegalTemplate>{content}</LegalTemplate>
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default SubprocessorPage;
